import React from "react";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo.png";
import "./PoweredByTipify.css";

const PoweredByTipify = () => {
  const { t } = useTranslation();

  return (
    <>
      <div aria-hidden="true" className="powered-by-spacer" />
      <div
        style={{
          position: "fixed",
          bottom: "calc(10px + var(--cookie-bar-h, 0px))",
          right: "10px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          zIndex: 1000,
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          borderRadius: "8px",
          padding: "6px 10px",
        }}
      >
        <span style={{ fontSize: "10px", color: "#666", marginTop: "5px" }}>{t("common.poweredBy")}</span>
        <a
          href="https://tipify.tech"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img
            src={logo}
            alt="Tipify"
            style={{ height: "22px", width: "auto" }}
          />
        </a>
      </div>
    </>
  );
};

export default PoweredByTipify;

